import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', to: '/' },
    { label: 'Design Your Shirt', to: '/customize' },
    { label: 'Shop Bulldogs Tees', to: '/shop' },
    { label: 'Best Sellers', to: '/best-sellers' },
    { label: 'About', to: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-black/50 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        {/* Nav Links */}
        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-semibold transition-colors whitespace-nowrap uppercase ${
                scrolled ? 'text-gray-800 hover:text-[#6B0000]' : 'text-white hover:text-red-200'
              }`}
              style={{ letterSpacing: '0.08em' }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-4 ml-auto">
          <button
            className={`flex items-center gap-2 transition-colors whitespace-nowrap ${
              scrolled ? 'text-gray-800 hover:text-[#6B0000]' : 'text-white hover:text-red-200'
            }`}
          >
            <div className="w-6 h-6 flex items-center justify-center relative">
              <i className="ri-shopping-cart-line text-xl"></i>
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#6B0000] text-white text-xs rounded-full flex items-center justify-center font-bold">
                0
              </span>
            </div>
            <span className="text-sm font-semibold hidden sm:inline tracking-widest uppercase">Cart</span>
          </button>
          <button
            className={`md:hidden transition-colors ${scrolled ? 'text-gray-800' : 'text-white'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </div>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              className="block px-6 py-3 text-sm font-semibold text-gray-800 hover:bg-red-50 hover:text-[#6B0000] transition-colors tracking-widest uppercase"
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
